import { transparentize } from 'polished';
import styled from 'styled-components';

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  margin-bottom: 1rem;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  border: 1px solid ${({ theme }) => theme.COLORS.GREEN_30};
  background-color: ${({ $active, theme }) =>
    $active ? theme.COLORS.GREEN_30 : 'transparent'};
  color: ${({ $active, theme }) =>
    $active ? theme.COLORS.WHITE : theme.COLORS.GREEN_30};
  padding: 0.5rem 1rem;
  border-radius: 0.45rem;
  font-size: 0.85rem;
  font-weight: bold;
  cursor: pointer;
  transition: 0.2s all;

  &:hover {
    filter: brightness(0.95);
  }
`;

export const PhotosGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  justify-content: center;
`;

export const PhotoCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;
  border-radius: 0.4rem;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  padding: 2rem 0;
  text-align: center;
  color: ${({ theme }) => transparentize(0.3, theme.COLORS.GREY)};
`;
